import script from "./color-input.vue?vue&type=script&setup=true&lang=js"
export * from "./color-input.vue?vue&type=script&setup=true&lang=js"

import "./color-input.vue?vue&type=style&index=0&id=6330e979&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6330e979"]])

export default __exports__